(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[161],{

/***/ 309:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/comprar-grama/[province]",
      function () {
        return __webpack_require__(8154);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(979);
/* harmony import */ var components_Layout_Default__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7309);
/* harmony import */ var components_Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1344);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3194);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _index_page__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1171);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7294);








var Contato = function(param) {
    var provinceName = param.provinceName, provinceSigla = param.provinceSigla, cities = param.cities, title = param.title, description = param.description, keywords = param.keywords, tip = param.tip;
    var handleItemClick = function handleItemClick(url) {
        router.push(url);
    };
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(), search = ref[0], setSearch = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Layout_Default__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        category: "Selecione sua cidade",
        categorySize: "25px",
        title: title,
        description: description,
        keywords: keywords,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Container__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .kC, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_3__/* .Left */ .dv, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_3__/* .WrapperItemList */ .de, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Input */ .II, {
                                        placeholder: "Filtre aqui pelo nome da sua cidade",
                                        onChange: function(e) {
                                            return setSearch(e.target.value);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                    search && (cities === null || cities === void 0 ? void 0 : cities.map(function(item) {
                                        return item.toLowerCase().includes(search.toLowerCase()) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_3__/* .ItemList */ .sr, {
                                            onClick: function() {
                                                return handleItemClick("/comprar-grama/".concat(provinceSigla.toLowerCase(), "/").concat((0,_index_page__WEBPACK_IMPORTED_MODULE_5__.transformarParaUrlAmigavel)(item)));
                                            },
                                            children: item
                                        }, "item-searched-".concat(item));
                                    })),
                                    !search && (cities === null || cities === void 0 ? void 0 : cities.map(function(item) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_3__/* .ItemList */ .sr, {
                                            onClick: function() {
                                                return handleItemClick("/comprar-grama/".concat(provinceSigla.toLowerCase(), "/").concat((0,_index_page__WEBPACK_IMPORTED_MODULE_5__.transformarParaUrlAmigavel)(item)));
                                            },
                                            children: item
                                        }, "item-no-search-".concat(item));
                                    }))
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_3__/* .Right */ .O6, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_3__/* .About */ .CL, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        children: "Dica r\xe1pida"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_3__/* .Item */ .ck, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
                                            children: tip
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Contato);


/***/ }),

/***/ 3194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CL": function() { return /* binding */ About; },
/* harmony export */   "D7": function() { return /* binding */ TextContent; },
/* harmony export */   "Dx": function() { return /* binding */ Title; },
/* harmony export */   "O6": function() { return /* binding */ Right; },
/* harmony export */   "c_": function() { return /* binding */ TableTh; },
/* harmony export */   "ck": function() { return /* binding */ Item; },
/* harmony export */   "de": function() { return /* binding */ WrapperItemList; },
/* harmony export */   "dv": function() { return /* binding */ Left; },
/* harmony export */   "ge": function() { return /* binding */ TableTd; },
/* harmony export */   "hh": function() { return /* binding */ TextLink; },
/* harmony export */   "iA": function() { return /* binding */ Table; },
/* harmony export */   "kC": function() { return /* binding */ Flex; },
/* harmony export */   "l0": function() { return /* binding */ Form; },
/* harmony export */   "mo": function() { return /* binding */ ImageContainer; },
/* harmony export */   "rj": function() { return /* binding */ Grid; },
/* harmony export */   "sr": function() { return /* binding */ ItemList; },
/* harmony export */   "wn": function() { return /* binding */ TableTr; },
/* harmony export */   "xJ": function() { return /* binding */ TableContainer; },
/* harmony export */   "xv": function() { return /* binding */ Text; },
/* harmony export */   "zx": function() { return /* binding */ Button; }
/* harmony export */ });
/* unused harmony exports Map, IconWrap, Label */
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7573);
/* harmony import */ var styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4767);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8641);
/* harmony import */ var components_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8859);




var Map = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("div", {
    width: "100%",
    height: 200,
    marginBottom: 50,
    background: "#A7C2B9",
    "@lg": {
        height: 350,
        marginBottom: 112
    }
});
var Flex = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("div", {
    "@lg": {
        display: "flex",
        flexDirection: "column",
        alignContent: "center"
    }
});
var Left = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("div", {
    flex: 1,
    marginBottom: 50,
    "@lg": {
        marginBottom: 0
    }
});
var Form = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("form", {
    marginTop: 15,
    "@md": {
        marginTop: 32
    }
});
var Grid = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Grid */ .rj, {
    gridTemplateColumns: "repeat(1, 1fr)",
    "@md": {
        gridTemplateColumns: "repeat(2, 1fr)"
    }
});
var Right = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("aside", {
    flex: 1,
    "@lg": {
        marginLeft: 94,
        maxWidth: 400
    }
});
var Button = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)(components_Button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    position: "relative",
    marginTop: 56,
    "& svg": {
        marginLeft: 5,
        marginTop: "-2px"
    }
});
var About = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("div", {
    padding: 16,
    position: "sticky",
    top: 10,
    borderRadius: 4,
    maxWidth: "100% !important",
    "@lg": {
        padding: 48
    },
    "& h4": {
        fontSize: "28px !important",
        marginBottom: 40
    }
});
var Item = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("div", {
    display: "flex",
    alignItems: "center",
    "&:not(:last-of-type)": {
        paddingBottom: 35,
        marginBottom: 35,
        borderBottom: "solid 1px",
        borderBottomColor: "$emerald500"
    }
});
var IconWrap = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("div", {
    width: 60,
    height: 60,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 10,
    borderRadius: "100%",
    background: "$emerald100"
});
var Label = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("p", {
    fontFamily: "$domine",
    fontWeight: "bold",
    fontSize: (0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(14),
    color: "$grey900"
});
var Text = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("p", {
    fontFamily: "$domine",
    fontSize: (0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(14),
    color: "$grey600",
    marginLeft: "auto"
});
var TableContainer = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("div", {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginTop: (0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(22)
});
var TextContent = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("p", {
    fontFamily: "$domine",
    fontSize: (0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(14),
    color: "$grey600",
    marginBottom: (0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(22)
});
var TextLink = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("a", {
    fontFamily: "$domine",
    fontSize: (0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(14),
    color: "$grey600",
    textDecoration: "underline"
});
var Title = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("h2", {
    fontSize: "37px !important",
    marginTop: (0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(22),
    marginBottom: (0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(22)
});
var Table = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("table", {
    borderCollapse: "collapse"
});
var TableTh = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("th", {
    backgroundColor: "#f2f2f2",
    border: "1px solid #ddd",
    padding: (0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(8)
});
var TableTd = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("td", {
    border: "1px solid #ddd",
    padding: "8px"
});
var TableTr = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("tr", {
    textAlign: "center"
});
var WrapperItemList = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("div", {
    maxWidth: "80%",
    margin: "0 auto"
});
var ItemList = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("div", {
    padding: "15px",
    backgroundColor: "$grey100",
    borderRadius: "8px",
    marginBottom: "10px",
    color: "$black",
    cursor: "pointer",
    "&:hover": {
        opacity: 0.5
    }
});
var ImageContainer = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("figure", {
    position: "relative",
    width: "80%",
    height: 250,
    marginBottom: 22,
    margin: " auto",
    border: "4px solid $white ",
    boxShadow: "0 0 8px rgba(0, 0, 0, 0.6)",
    "@md": {
        width: 550,
        height: 350,
        marginBottom: 22
    }
});


/***/ }),

/***/ 1171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ index_page; },
  "transformarParaUrlAmigavel": function() { return /* binding */ transformarParaUrlAmigavel; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react-input-mask/index.js
var react_input_mask = __webpack_require__(6627);
var react_input_mask_default = /*#__PURE__*/__webpack_require__.n(react_input_mask);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/form-control/dist/index.esm.js
var index_esm = __webpack_require__(3234);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/index.esm.js
var dist_index_esm = __webpack_require__(979);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var react_hook_form_dist_index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/index.esm.js
var icons_dist_index_esm = __webpack_require__(3382);
// EXTERNAL MODULE: ./components/Layout/Default/index.tsx + 1 modules
var Default = __webpack_require__(7309);
// EXTERNAL MODULE: ./components/Container/index.tsx
var Container = __webpack_require__(1344);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 6 modules
var polished_esm = __webpack_require__(7573);
// EXTERNAL MODULE: ./styles/stitches.config.ts
var stitches_config = __webpack_require__(4767);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var layout_dist_index_esm = __webpack_require__(8641);
// EXTERNAL MODULE: ./components/Button/index.tsx
var Button = __webpack_require__(8859);
;// CONCATENATED MODULE: ./pages/comprar-grama/styles.ts




var Map = (0,stitches_config/* styled */.zo)("div", {
    width: "100%",
    height: 200,
    marginBottom: 50,
    background: "#A7C2B9",
    "@lg": {
        height: 350,
        marginBottom: 112
    }
});
var Flex = (0,stitches_config/* styled */.zo)("div", {
    "@lg": {
        display: "flex",
        justifyContent: "space-between"
    }
});
var Left = (0,stitches_config/* styled */.zo)("div", {
    flex: 1,
    marginBottom: 50,
    "@lg": {
        marginBottom: 0
    }
});
var Form = (0,stitches_config/* styled */.zo)("form", {
    marginTop: 15,
    "@md": {
        marginTop: 32
    }
});
var Grid = (0,stitches_config/* styled */.zo)(layout_dist_index_esm/* Grid */.rj, {
    gridTemplateColumns: "repeat(1, 1fr)",
    "@md": {
        gridTemplateColumns: "repeat(2, 1fr)"
    }
});
var Right = (0,stitches_config/* styled */.zo)("aside", {
    flex: 1,
    "@lg": {
        marginLeft: 94,
        maxWidth: 400
    }
});
var styles_Button = (0,stitches_config/* styled */.zo)(Button/* default */.Z, {
    position: "relative",
    marginTop: 56,
    "& svg": {
        marginLeft: 5,
        marginTop: "-2px"
    }
});
var About = (0,stitches_config/* styled */.zo)("div", {
    padding: 16,
    borderRadius: 4,
    background: "$emerald50",
    border: "solid 1px",
    borderColor: "$emerald500",
    "@lg": {
        padding: 48
    },
    "& h4": {
        fontSize: "28px !important",
        marginBottom: 40
    }
});
var Item = (0,stitches_config/* styled */.zo)("div", {
    display: "flex",
    alignItems: "center",
    "&:not(:last-of-type)": {
        paddingBottom: 35,
        marginBottom: 35,
        borderBottom: "solid 1px",
        borderBottomColor: "$emerald500"
    }
});
var IconWrap = (0,stitches_config/* styled */.zo)("div", {
    width: 60,
    height: 60,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 10,
    borderRadius: "100%",
    background: "$emerald100"
});
var Label = (0,stitches_config/* styled */.zo)("p", {
    fontFamily: "$domine",
    fontWeight: "bold",
    fontSize: (0,polished_esm/* rem */.hO)(14),
    color: "$grey900"
});
var Text = (0,stitches_config/* styled */.zo)("p", {
    fontFamily: "$domine",
    fontSize: (0,polished_esm/* rem */.hO)(14),
    color: "$grey600",
    marginLeft: "auto"
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./pages/components/Loading/index.js
var Loading = __webpack_require__(3229);
;// CONCATENATED MODULE: ./pages/comprar-grama/index.page.js
















function transformarParaUrlAmigavel(str) {
    // remover acentos, espaços e caracteres especiais
    str = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    str = str.replace(/[^a-zA-Z0-9 ]/g, "");
    // converter para minúsculas e substituir espaços por hifens
    str = str.toLowerCase().replace(/\s+/g, "-");
    return str;
}
var Contato = function() {
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)(false), error = ref1[0], setError = ref1[1];
    var ref2 = (0,react.useState)(false), success = ref2[0], setSuccess = ref2[1];
    var router = (0,next_router.useRouter)();
    var ref3 = (0,react_hook_form_dist_index_esm/* useForm */.cI)(), register = ref3.register, handleSubmit = ref3.handleSubmit, errors = ref3.formState.errors;
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return axios_default().get("https://viacep.com.br/ws/".concat(payload.cep, "/json/"));
                    case 4:
                        data = _ctx.sent.data;
                        setSuccess(true);
                        setError(false);
                        window === null || window === void 0 ? void 0 : window.scrollTo(0, 0);
                        router.push("/comprar-grama/".concat(transformarParaUrlAmigavel(data.uf), "/").concat(transformarParaUrlAmigavel(data.localidade)));
                        _ctx.next = 16;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        setError(true);
                        setSuccess(false);
                        setTimeout(function() {
                            setError(false);
                            setSuccess(false);
                        }, 3000);
                    case 16:
                        _ctx.prev = 16;
                        setLoading(false);
                        return _ctx.finish(16);
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11,
                    16,
                    19
                ]
            ]);
        }));
        return function onSubmit(payload) {
            return _ref.apply(this, arguments);
        };
    }();
    var cepRef = register("cep");
    var handleCepChange = function(e) {
        cepRef === null || cepRef === void 0 ? void 0 : cepRef.onChange(e);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Default/* default */.Z, {
        category: "Or\xe7amento R\xe1pido",
        title: "Comprar Grama para sua cidade",
        description: "Compre grama direto do produtor para todo o Brasil, basta informar o seu CEP que abrir\xe1 automaticamente o formul\xe1rio de or\xe7amento, prazo de retorno s\xe3o 24 horas \xfateis...",
        keywords: "comprar grama, comprar grama sp, comprar grama rj, comprar grama mg, comprar grama es, comprar grama pr, comprar grama sc, comprar grama rs, comprar grama go, comprar grama mt, comprar grama ms, comprar grama df, comprar grama ba",
        categorySize: "1.6rem",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {
                    isLoading: loading
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Left, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: "Qual \xe9 o CEP de onde voc\xea quer comprar grama?"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form, {
                                    onSubmit: handleSubmit(onSubmit),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid, {
                                            gap: "24px",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* FormControl */.NI, {
                                                isInvalid: errors.cep,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((react_input_mask_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                        mask: "99999-999",
                                                        maskChar: "",
                                                        onChange: handleCepChange,
                                                        value: cepRef.value
                                                    }, register("cep", {
                                                        required: "Este campo \xe9 obrigat\xf3rio"
                                                    })), {
                                                        children: function() {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Input */.II, {
                                                                type: "tel",
                                                                placeholder: "Cep",
                                                                name: "cep"
                                                            });
                                                        }
                                                    })),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormErrorMessage */.J1, {
                                                        children: errors.cep && errors.cep.message
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Button, {
                                            disabled: loading,
                                            shape: "rounded",
                                            title: "comprar grama para o meu cep",
                                            children: [
                                                "Pŕoximo passo ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_dist_index_esm/* ArrowForwardIcon */.mr, {
                                                    w: 4,
                                                    h: 4
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var index_page = (Contato);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [753,921,112,434,774,888,179], function() { return __webpack_exec__(309); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);